<template>

    <v-text-field
        autocomplete="kPass"
        light
        name="kPass"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showPassword = !showPassword"
        :type="showPassword ? 'text' : 'password'"
        :value="value"
        @input="updateValue($event)"
        :label="$t(label)"
        :hint="score.msg"
        :rules="[rules.required, rules.minPassword(minLength, value)]"
        loading
        validate-on-blur>

        <template v-slot:progress>
            <v-progress-linear height="4" absolute :color="score.color" :value="score.value"></v-progress-linear>
        </template>

    </v-text-field>

</template>


<script>
const zxcvbn = require('zxcvbn');

export default {

    props: {
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: 'PASSWORD'
        },
        minLength: {
            type: Number,
            default: 12
        }
    },

    data() {

        return {
            showPassword: false,

        }

    },

    computed: {

        score() {

            let p = this.value == null ? "" : this.value;

            const result = zxcvbn(p);

            switch(result.score) {
                case 4:
                    return {
                        msg: result.feedback.warning,
                        color: "green",
                        value: 100
                    };
                case 3:
                    return {
                        msg: result.feedback.warning,
                        color: "light-green",
                        value: 75
                    };
                case 2:
                    return {
                        msg: result.feedback.warning,
                        color: "yellow",
                        value: 50
                    };

                case 1:
                    return {
                        msg: result.feedback.warning,
                        color: "orange",
                        value: 25
                    };

                default:
                    return {
                        msg: result.feedback.warning,
                        color: "red",
                        value: 0
                    };
            }

        }

    },

    created() {


    },

    mounted() {


    },

    methods: {

        updateValue(value) {
            this.$emit('input', value);
        }

    }


}
</script>


<style lang="scss">


</style>
